import React, { useEffect } from "react";
import {
  Button,
  Icon,
  Popconfirm,
  Table,
  Popover,
  Tag,
  Row,
  Col,
  Tooltip
} from "antd";
import update from "immutability-helper";

import { hot } from "react-hot-loader";
import components from "./TableComponents";
import withDragDropContext from "./withDNDContext";
import { getMaxIndex } from "../../utils/common";
const colors = [
  "magenta",
  "red",
  "volcano",
  "orange",
  "gold",
  "lime",
  "green",
  "cyan",
  "blue",
  "geekblue",
  "purple"
];

function CustomFieldsOptions({ ...props }) {
  const [state, setLocalOptions] = React.useState<any>({
    operating: false,
    localOptions: [],
    editingKey: 1
  });

  let addButton: Button | null = null;
  let options = props.value;
  useEffect(() => {
    if (props.value && props.value instanceof Array) {
      // console.log({ vaule: props.value });
      setLocalOptions({ ...state, localOptions: props.value });
    }
    if (state.editingKey === false) {
      // handleEditKeyChange(props.value[0] ? props.value[0].order || 1 : 1);
    }
    document.addEventListener("keydown", shiftEnterFunction, false);
  }, []);

  const shiftEnterFunction = e => {
    if (
      e.shiftKey &&
      state.operating === false &&
      (e.keyCode === 13 || e.key === "Enter")
    ) {
      if (
        addButton &&
        addButton["buttonNode"] &&
        addButton["buttonNode"].focus
      ) {
        addButton["buttonNode"].focus();
      }
    }
  };

  const onDelete = (order: number) => {
    const index = options.findIndex(item => order === item.order);
    options.splice(index, 1);
    props.onChange(options);
    setLocalOptions({ ...state, localOptions: options });
  };

  const updateStep = (field, newVal, index) => {
    options[index][field] = newVal;
    props.onChange(options);
    setLocalOptions({ ...state, localOptions: options });
  };

  const handleEditKeyChange = key => {
    setLocalOptions({ ...state, editingKey: key });
  };

  const addOption = (latest = undefined) => {
    let values = latest && latest instanceof Array ? latest : options;
    const systemValue = getMaxIndex(options) || 1;
    let order = 1;
    if (values) {
      const last_option = options[options.length - 1];
      if (last_option) {
        order = last_option.order + 1;
        values.splice(options.length, 0, {
          systemValue,
          order,
          label: "Type an option name"
          //label: "Option name"
        });
      } else {
        order = options.length + 1;
        values.splice(options.length, 0, {
          systemValue,
          order: options.length + 1,
          label: "Type an option name"
          //label: "Option name"
        });
      }
    } else {
      values = [
        {
          systemValue,
          order
          //label: "Option name"
        }
      ];
    }

    props.onChange(values);
    setLocalOptions({ ...state, localOptions: values });
    handleEditKeyChange(order);
  };

  const handleSave = (row, onEnter = false) => {
    const newData = [...options];
    const index = newData.findIndex(item => row.order === item.order);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row
    });
    props.onChange(newData);
    setLocalOptions({ operating: false, localOptions: newData });
    // callback(true);
    if (onEnter && state.editingKey === newData[newData.length - 1].order)
      addOption(newData);
    // setTimeout(addOption, 500);
    return false;
    // if (addButton && addButton.buttonNode && addButton.buttonNode.focus) {
    //   addButton.buttonNode.focus();
    // }
  };

  const content = record => {
    // const {record, }
    return colors.map(color => (
      <Tag
        color={color}
        onClick={() => {
          handleSave({ ...record, color });
        }}
      >
        {color}
      </Tag>
    ));
  };
  const columns = [
    {
      dataIndex: "label",
      colSpan: 2,
      render: () => <Icon type="small-dash" />
    },
    {
      title: "",
      dataIndex: "label",
      editable: true,
      colSpan: 10,
      render: (label, record) => (
        <Button type="ghost" size="default">
          {label ? label : "Type an option name"}
        </Button>
      ),
      onCell: record => ({
        record,
        addOption,
        editable: true,
        dataIndex: "label",
        title: "title",
        handleSave: handleSave,
        onClickTitle: handleEditKeyChange,
        editingKey: state.editingKey,
        onDelete: () => onDelete(record.order)
      })
    },
    {
      title: "",
      dataIndex: "operation",
      colSpan: 2,
      render: (text, record) => {
        return state.localOptions.length >= 1 ? (
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onDelete(record.order)}
          >
            <Icon type="delete" />
          </Popconfirm>
        ) : null;
      }
    }
  ];

  const moveRow = (dragIndex, hoverIndex) => {
    const data =
      state.localOptions && state.localOptions.length
        ? state.localOptions
        : props.value && Array.isArray(props.length) && props.value.length
          ? props.value
          : [];
    console.log({ data, props });
    let dragRow = data[dragIndex];
    dragRow = { ...dragRow, order: hoverIndex + 1 };
    const newData = update(data, {
      $splice: [[dragIndex, 1], [hoverIndex, 0, dragRow]]
    });
    if (dragIndex > hoverIndex) {
      // Upward drag
      for (let i = hoverIndex + 1; i <= dragIndex; i++) {
        newData[i] = { ...newData[i], order: i + 1 };
      }
    } else {
      // Downward drag
      for (let i = hoverIndex - 1; i >= dragIndex; i--) {
        newData[i] = { ...newData[i], order: i + 1 };
      }
    }
    props.onChange(newData);
    setLocalOptions({ operating: false, localOptions: newData });
  };

  return (
    <div>
      {/* {options.map((option, index) => (
        <Form.Item key={`option_${index}`} label="Option">
          <Input
            value={option.label}
            onChange={e => updateStep("label", e.target.value, index)}
            placeholder="Enter Option"
            suffix={<Icon type="close" onClick={() => onDelete(index)} />}
            onKeyDown={event => {
              if (event.key === "Enter") {
                event.preventDefault();
                addOption();
              }
            }}
          />
        </Form.Item>
      ))} */}

      <Table
        components={components}
        rowClassName={() => "editable-row"}
        dataSource={options}
        columns={columns}
        rowKey={(record, index) => {
          return record.systemValue || index;
        }}
        showHeader={false}
        bordered={false}
        pagination={false}
        loading={state.oprating}
        onRow={(record, index) => ({
          index,
          moveRow: moveRow
        })}
        size="small"
        // style={{ width: "50%" }}
      />

      <Tooltip title="Insert a new option">
        <Button
          type="primary"
          shape="circle"
          icon="plus"
          onClick={addOption}
          ref={node => {
            addButton = node;
          }}
          style={{ float: "right", marginTop: "5px" }}
        />
      </Tooltip>
    </div>
  );
}
const Options = withDragDropContext(CustomFieldsOptions);
export default hot(module)(Options);
